/** Los vehículos de un bono del listado (f74): [{ vehiculo, anio, colores, cobertura, img_url }]. */
export const vehiculosDe = (b) => {
  try {
    const v = JSON.parse(b && b.vehiculos ? b.vehiculos : '[]')
    return Array.isArray(v) ? v : []
  } catch (e) {
    return []
  }
}

/**
 * F88: motos de la misma campaña de TP que esperan llegar al catálogo de Lucia, agrupadas por vehículo:
 * [{ vehiculo, colores: [{ color, material, sku }] }]. Entran solas al bono cuando la moto llega.
 */
const listaPendientes = (b) => {
  try {
    const v = JSON.parse(b && b.pendientes ? b.pendientes : '[]')
    return Array.isArray(v) ? v : []
  } catch (e) {
    return []
  }
}

export const pendientesDe = (b) => {
  // f98: las cargadas desde Lucia (origen 'lucia') van aparte, en pendientesLuciaDe: esas se editan.
  const lista = listaPendientes(b).filter((p) => p.origen !== 'lucia')
  const mapa = new Map()
  lista.forEach((p) => {
    const veh = String(p.vehiculo || '').replace(/^MOTO\s+/i, '').trim() || 'Sin nombre en TP'
    if (!mapa.has(veh)) mapa.set(veh, { vehiculo: veh, colores: [] })
    mapa.get(veh).colores.push({ color: String(p.color || '').trim(), material: p.material || '', sku: p.sku || '' })
  })
  return [...mapa.values()]
}

/**
 * F98: motos que se cargaron en el bono desde Lucia y aún no están en el catálogo:
 * [{ material, vehiculo, cobertura, legal, img_url, precio_antes }] (f99: lo del paso 4 de esa moto).
 * Temporal: el import del catálogo las pasa al bono el día que llegan.
 */
export const pendientesLuciaDe = (b) => listaPendientes(b)
  .filter((p) => p.origen === 'lucia')
  .map((p) => ({
    material: String(p.material || ''),
    vehiculo: String(p.vehiculo || ''),
    cobertura: String(p.cobertura || ''),
    legal: String(p.legal || ''),
    img_url: String(p.img_url || ''),
    precio_antes: p.precio_antes != null && Number(p.precio_antes) > 0 ? String(p.precio_antes) : '',
  }))

/**
 * F95: el precio de la moto con el bono, con la MISMA regla que la API (`precio_con_bono`):
 *   precio estructural        -> el precio de SAP (o el PVP si SAP no tiene)
 *   tacha / precio_financiera -> PVP - monto
 *   beneficio                 -> el PVP (el bono no toca el precio)
 * `precio` es el PVP de la moto en Lucia (pvp_actual); 0 = sin precio -> null.
 */
export const precioConBono = ({ precio = 0, sap = 0, efecto = '', monto = 0, estructural = false }) => {
  const p = Number(precio) || 0
  if (!p) return null
  if (estructural) return Number(sap) || p
  if (efecto === 'tacha' || efecto === 'precio_financiera') return p - (Number(monto) || 0)
  return p
}

/** 'Nacional' o 'APLICA A NIVEL NACIONAL' (así viene de VTEX) cuentan como nacional; 'Varía…' no. */
export const esNacional = (cob) => /nacional/i.test(String(cob || '')) && !/vari/i.test(String(cob || ''))
